import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { PhoneModelsComponent } from './phone-models.component';
import { Searchfilter } from '../common/SearchFilter';
import {DataTableModule} from 'angular2-datatable';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NotifierModule } from 'angular-notifier';
import {ExcelService} from '../common/API/excel.service';
import { MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, 
  MatSortModule, MatTableModule } from "@angular/material";

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

const routerConfig = [{
  path: '',
  component: PhoneModelsComponent
}];

@NgModule({
  imports: [
    CommonModule,UiSwitchModule,
    RouterModule.forChild(routerConfig),
    NgMultiSelectDropDownModule.forRoot(),MatInputModule, MatPaginatorModule, MatProgressSpinnerModule, 
    MatSortModule, MatTableModule ,
    ReactiveFormsModule,DataTableModule,NotifierModule.withConfig({
      position: {
        horizontal: {
          position: 'right',
          distance: 12
        },
        vertical: {
          position: 'top',
          distance: 12,
          gap: 10
        }
      },
      theme: 'material',
      behaviour: {
        autoHide: 2000,
        onClick: false,
        onMouseover: 'pauseAutoHide',
        showDismissButton: false,
        stacking: 1
      },
      animations: {
        enabled: true,
        show: {
          preset: 'slide',
          speed: 200,
          easing: 'ease'
        },
        hide: {
          preset: 'fade',
          speed: 300,
          easing: 'ease',
          offset: 50
        },
        shift: {
          speed: 300,
          easing: 'ease'
        },
        overlap: 150
      }
    })
  ],
  declarations: [
    PhoneModelsComponent,Searchfilter
  ],
  exports: [
    PhoneModelsComponent
  ],
  providers: [ExcelService]
})

export class PhoneModelsModule { }

